import { TRefTypeId as TRefTypeId$1, get as get$1, getAndSet as getAndSet$1, getAndUpdate as getAndUpdate$1, getAndUpdateSome as getAndUpdateSome$1, make as make$1, modify as modify$1, modifySome as modifySome$1, set as set$1, setAndGet as setAndGet$1, update as update$1, updateAndGet as updateAndGet$1, updateSome as updateSome$1, updateSomeAndGet as updateSomeAndGet$1 } from '../../internal/stm/tRef.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const TRefTypeId = TRefTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `TRef<A>` is a purely functional description of a mutable reference that can
 * be modified as part of a transactional effect. The fundamental operations of
 * a `TRef` are `set` and `get`. `set` transactionally sets the reference to a
 * new value. `get` gets the current value of the reference.
 *
 * NOTE: While `TRef<A>` provides the transactional equivalent of a mutable
 * reference, the value inside the `TRef` should be immutable.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @internal
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category mutations
 */
const get = get$1;

/**
 * @since 2.0.0
 * @category mutations
 */
const getAndSet = getAndSet$1;

/**
 * @since 2.0.0
 * @category mutations
 */
const getAndUpdate = getAndUpdate$1;

/**
 * @since 2.0.0
 * @category mutations
 */
const getAndUpdateSome = getAndUpdateSome$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const make = make$1;

/**
 * @since 2.0.0
 * @category mutations
 */
const modify = modify$1;

/**
 * @since 2.0.0
 * @category mutations
 */
const modifySome = modifySome$1;

/**
 * @since 2.0.0
 * @category mutations
 */
const set = set$1;

/**
 * @since 2.0.0
 * @category mutations
 */
const setAndGet = setAndGet$1;

/**
 * @since 2.0.0
 * @category mutations
 */
const update = update$1;

/**
 * @since 2.0.0
 * @category mutations
 */
const updateAndGet = updateAndGet$1;

/**
 * @since 2.0.0
 * @category mutations
 */
const updateSome = updateSome$1;

/**
 * @since 2.0.0
 * @category mutations
 */
const updateSomeAndGet = updateSomeAndGet$1;

export { TRefTypeId, get, getAndSet, getAndUpdate, getAndUpdateSome, make, modify, modifySome, set, setAndGet, update, updateAndGet, updateSome, updateSomeAndGet };
